import {identityTypes} from './types';

const identity = {
    site:{
        title: "Collection Jessula — Léna Durr",
        description: "",
        fullTitle: "Collection Jessula",
    },
    menus: {
        mainMenu:[
            {
                title:'Page dédiée au projet sur le site du Nouveau Musée National de Monaco', 
                href:'https://www.nmnm.mc/evenements/la-collection-jessula/', 
                hasPopover:true, 
                target:'_blank'
            },
        ],
    }
};

identity.propTypes = identityTypes;

export default identity;